import {Grid, Typography} from "@mui/material";

export const Tarjeta_Adicional_Acompanante = ({item}) => {

    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: 12, fontWeight: 800}}>{`${item.tipoCc} ${item.cc}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}}>
                <Typography sx={{fontWeight: 300}}>{`${item.nombres} ${item.apellidos}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 3}} justifyContent={'flex-end'}>
                <Typography sx={{fontWeight: 800}}>{item.edad}</Typography>
            </Grid>


        </Grid>
    )
}